const translate_en = {
  translation: {
    // country codes
    countryCodes: {
      // special codes
      AC: 'Ascension Island',
      TA: 'Tristan da Cunha',
      XK: 'Kosovo',
      // official codes
      AD: 'Andorra',
      AE: 'United Arab Emirates',
      AF: 'Afghanistan',
      AG: 'Antigua and Barbuda',
      AI: 'Anguilla',
      AL: 'Albania',
      AM: 'Armenia',
      AO: 'Angola',
      AQ: 'Antarctica',
      AR: 'Argentina',
      AS: 'American Samoa',
      AT: 'Austria',
      AU: 'Australia',
      AW: 'Aruba',
      AX: 'Åland Islands',
      AZ: 'Azerbaijan',
      BA: 'Bosnia and Herzegovina',
      BB: 'Barbados',
      BD: 'Bangladesh',
      BE: 'Belgium',
      BF: 'Burkina Faso',
      BG: 'Bulgaria',
      BH: 'Bahrain',
      BI: 'Burundi',
      BJ: 'Benin',
      BL: 'Saint Barthélemy',
      BM: 'Bermuda',
      BN: 'Brunei',
      BO: 'Bolivia',
      BQ: 'Bonaire, Sint Eustatius and Saba',
      BR: 'Brazil',
      BS: 'Bahamas',
      BT: 'Bhutan',
      BV: 'Bouvet Island',
      BW: 'Botswana',
      BY: 'Belarus',
      BZ: 'Belize',
      CA: 'Canada',
      CC: 'Cocos (Keeling) Islands',
      CD: 'Congo (Democratic Republic)',
      CF: 'Central African Republic',
      CG: 'Congo',
      CH: 'Switzerland',
      CI: "Côte d'Ivoire",
      CK: 'Cook Islands',
      CL: 'Chile',
      CM: 'Cameroon',
      CN: 'China',
      CO: 'Colombia',
      CR: 'Costa Rica',
      CU: 'Cuba',
      CV: 'Cape Verde',
      CW: 'Curaçao',
      CX: 'Christmas Island',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DE: 'Germany',
      DJ: 'Djibouti',
      DK: 'Denmark',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      DZ: 'Algeria',
      EC: 'Ecuador',
      EE: 'Estonia',
      EG: 'Egypt',
      EH: 'Western Sahara',
      ER: 'Eritrea',
      ES: 'Spain',
      ET: 'Ethiopia',
      FI: 'Finland',
      FJ: 'Fiji',
      FK: 'Falkland Islands',
      FM: 'Micronesia',
      FO: 'Faroe Islands',
      FR: 'France',
      GA: 'Gabon',
      GB: 'United Kingdom',
      GD: 'Grenada',
      GE: 'Georgia',
      GF: 'French Guiana',
      GG: 'Guernsey',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GL: 'Greenland',
      GM: 'Gambia',
      GN: 'Guinea',
      GP: 'Guadeloupe',
      GQ: 'Equatorial Guinea',
      GR: 'Greece',
      GS: 'South Georgia and the South Sandwich Islands',
      GT: 'Guatemala',
      GU: 'Guam',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HK: 'Hong Kong',
      HM: 'Heard Island and McDonald Islands',
      HN: 'Honduras',
      HR: 'Croatia',
      HT: 'Haiti',
      HU: 'Hungary',
      ID: 'Indonesia',
      IE: 'Ireland',
      IL: 'Israel',
      IM: 'Isle of Man',
      IN: 'India',
      IO: 'British Indian Ocean Territory',
      IQ: 'Iraq',
      IR: 'Iran',
      IS: 'Iceland',
      IT: 'Italy',
      JE: 'Jersey',
      JM: 'Jamaica',
      JO: 'Jordan',
      JP: 'Japan',
      KE: 'Kenya',
      KG: 'Kyrgyzstan',
      KH: 'Cambodia',
      KI: 'Kiribati',
      KM: 'Comoros',
      KN: 'Saint Kitts and Nevis',
      KP: 'North Korea',
      KR: 'South Korea',
      KW: 'Kuwait',
      KY: 'Cayman Islands',
      KZ: 'Kazakhstan',
      LA: 'Laos',
      LB: 'Lebanon',
      LC: 'Saint Lucia',
      LI: 'Liechtenstein',
      LK: 'Sri Lanka',
      LR: 'Liberia',
      LS: 'Lesotho',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      LV: 'Latvia',
      LY: 'Libya',
      MA: 'Morocco',
      MC: 'Monaco',
      MD: 'Moldova',
      ME: 'Montenegro',
      MF: 'Saint Martin (French part)',
      MG: 'Madagascar',
      MH: 'Marshall Islands',
      MK: 'Macedonia',
      ML: 'Mali',
      MM: 'Myanmar',
      MN: 'Mongolia',
      MO: 'Macao',
      MP: 'Northern Mariana Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MS: 'Montserrat',
      MT: 'Malta',
      MU: 'Mauritius',
      MV: 'Maldives',
      MW: 'Malawi',
      MX: 'Mexico',
      MY: 'Malaysia',
      MZ: 'Mozambique',
      NA: 'Namibia',
      NC: 'New Caledonia',
      NE: 'Niger',
      NF: 'Norfolk Island',
      NG: 'Nigeria',
      NI: 'Nicaragua',
      NL: 'Netherlands',
      NO: 'Norway',
      NP: 'Nepal',
      NR: 'Nauru',
      NU: 'Niue',
      NZ: 'New Zealand',
      OM: 'Oman',
      PA: 'Panama',
      PE: 'Peru',
      PF: 'French Polynesia',
      PG: 'Papua New Guinea',
      PH: 'Philippines',
      PK: 'Pakistan',
      PL: 'Poland',
      PM: 'Saint Pierre and Miquelon',
      PN: 'Pitcairn',
      PR: 'Puerto Rico',
      PS: 'Palestine',
      PT: 'Portugal',
      PW: 'Palau',
      PY: 'Paraguay',
      QA: 'Qatar',
      RE: 'Réunion',
      RO: 'Romania',
      RS: 'Serbia',
      RU: 'Russia',
      RW: 'Rwanda',
      SA: 'Saudi Arabia',
      SB: 'Solomon Islands',
      SC: 'Seychelles',
      SD: 'Sudan',
      SE: 'Sweden',
      SG: 'Singapore',
      SH: 'Saint Helena, Ascension and Tristan da Cunha',
      SI: 'Slovenia',
      SJ: 'Svalbard and Jan Mayen',
      SK: 'Slovakia',
      SL: 'Sierra Leone',
      SM: 'San Marino',
      SN: 'Senegal',
      SO: 'Somalia',
      SR: 'Suriname',
      SS: 'South Sudan',
      ST: 'São Tomé and Príncipe',
      SV: 'El Salvador',
      SX: 'Sint Maarten (Dutch part)',
      SY: 'Syria',
      SZ: 'Eswatini',
      TC: 'Turks and Caicos Islands',
      TD: 'Chad',
      TF: 'French Southern Territories',
      TG: 'Togo',
      TH: 'Thailand',
      TJ: 'Tajikistan',
      TK: 'Tokelau',
      TL: 'Timor-Leste',
      TM: 'Turkmenistan',
      TN: 'Tunisia',
      TO: 'Tonga',
      TR: 'Turkey',
      TT: 'Trinidad and Tobago',
      TV: 'Tuvalu',
      TW: 'Taiwan',
      TZ: 'Tanzania',
      UA: 'Ukraine',
      UG: 'Uganda',
      UM: 'United States Minor Outlying Islands',
      US: 'United States',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VA: 'Vatican City',
      VC: 'Saint Vincent and the Grenadines',
      VE: 'Venezuela',
      VG: 'British Virgin Islands',
      VI: 'United States Virgin Islands',
      VN: 'Vietnam',
      VU: 'Vanuatu',
      WF: 'Wallis and Futuna',
      WS: 'Samoa',
      YE: 'Yemen',
      YT: 'Mayotte',
      ZA: 'South Africa',
      ZM: 'Zambia',
      ZW: 'Zimbabwe'
    },

    // Labels
    labels: {
      lblEmail: 'E-mail *',
      lblOccupation: 'Occupation *',
      lblNationalID: 'National ID *',
      lblNationalIDPlain: 'National ID',
      lblDriverLicence: 'Driver licence',
      lblDocumentType: 'Document type *',
      lblDocumentFront: 'Front of document *',
      lblDocumentBack: 'Back of document *',
      lblAddressProofOwner: 'Proof of address is in the name of *',
      lblAddressProofOwnerSelf: 'Shareholder / director',
      lblAddressProofOwnerOther: 'Another person',
      lblKinshipDegree: 'Relationship / kinship degree *',
      lblPassportMockupAlt: 'Passport document example',
      lblIdentityMockupAlt: 'National ID document example',
      lblDocumentExample: 'Document example',
      lblSeeExample: 'See example',
      lblScanPassport: 'Scan Passport',
      lblScanPassportHint: 'Point the camera at the passport data page. It reads on its own.',
      lblScanPassportPermission: 'Allow camera access to scan the passport.',
      lblScanPassportDenied:
        'Camera permission was denied. Enable it in the browser settings, send a photo of the document, or fill the fields manually.',
      lblScanPassportUnavailable: 'Camera is not available. Send a photo of the document or fill the fields manually.',
      lblScanPassportPreparing: 'Preparing the reader...',
      lblScanPassportSearching: 'Looking for the passport data...',
      lblScanPassportTip: 'Move the passport closer until the two bottom lines fill the frame, and avoid glare.',
      lblScanPassportFailed: 'Could not start the reader. Please try again.',
      lblScanPassportRetry: 'Try again',
      lblScanPassportUpload: 'Not working? Send a photo of the document',
      lblScanPassportCapture: 'Read this image',
      lblScanPassportCapturing: 'Reading the image...',
      lblScanPassportReadingPhoto: 'Reading the photo...',
      lblScanPassportPhotoFailed:
        'Could not read that photo. Send a sharp data page, without glare, with the two bottom lines visible.',
      lblScanPassportFound: 'We found these details',
      lblScanPassportReviewHint:
        'Check they look right before using them. The reader can mix up similar letters, such as S and B or G and O.',
      lblScanPassportUseData: 'Use these details',
      lblScanPassportScanAgain: 'Scan again',
      lblPassportExampleTitle: 'Passport example',
      lblIdentityExampleTitle: 'National ID example',
      lblIdentityOpenHint: 'Send the document open, with front and back visible',
      lblIdentityFront: 'Front',
      lblIdentityBack: 'Back',
      lblIdentityFrontAlt: 'National ID front',
      lblIdentityBackAlt: 'National ID back',
      lblSharesUnitsRangeHelper: 'Allowed range: 1 – 50,000',
      lblLastName: 'Last name *',
      lblFirstName: 'Name *',
      lblNotification: 'Notification',
      lblPassword: 'Password',
      lblConfirmPassword: 'Confirm Password',
      lblPronoun: 'Pronoun',
      lblLegalPersonality: 'Legal personality',
      lblCompanyProfile: 'Company Profile',
      lblJurisdictions: 'Jurisdiction',
      lblMainGoals: 'My main goals are',
      lblTypeOfCompany: 'Type of company',
      lblNumDirectors: 'Number of directors',
      lblNumMinors: 'Number of minors',
      lblNumShareholders: 'Number of shareholders',
      lblEntityDirectors: 'Entity directors',
      lblEntityDirectorsNames: 'Entity directors names',
      lblNumShareholdersUnderage: 'Number of shareholders underage',
      lblEntityPronoun: 'Entity Pronoun',
      lblEntityShareholders: 'Entity shareholders',
      lblEntityShareholdersNames: 'Entity shareholders names',
      lblEntityShareholdersUnderage: 'Entity shareholders underage',
      lblObjective: 'Objective',
      lblPersonality: 'Personality',
      lblRegistrationCountry: 'Registration country',
      lblWhyDidYouChoose: 'What are the advantages of this jurisdiction?',
      lblSelectStatus: 'Select Status',
      lblLoading: 'Loading',
      lblNoRecords: 'No records found',
      lblViewDetails: 'View Details',
      lblDetails: 'Details',
      lblAddons: 'Add-ons',
      lblNoAddons: 'No Add-ons',
      lblWhyShareholders: `
        <p>Consider in this count the total number of shareholders, regardless of whether they are directors or not, or if they have a small stake in the business.</p>

        <p>We would like to highlight our <strong>Know Your Customer (KYC)</strong> policies, which are stringent and in compliance with international laws and regulations. Our commitment is to maintain a safe and transparent business environment for all our clients.</p>

        <h5>Who may face restrictions:</h5>

        <p><strong>Politically Exposed Persons (PEPs)</strong>: Given the sensitive nature and the potential risk of corruption associated with PEPs, it is challenging for our company to approve such individuals without rigorous and extensive checks.</p>

        <p><strong>Public Officials</strong>: Those serving in public roles, especially in positions that influence financial decisions, are subject to more stringent KYC scrutiny and may not be approved.</p>

        <p><strong>Individuals Convicted of Crimes</strong>: Particularly those convicted of trafficking, financial crimes, or other serious offenses are unlikely to be approved through our KYC process.</p>

        <p><strong>No Proof of Income</strong>: Clients who cannot provide adequate proof of income or the source of funds may also face difficulties in passing our KYC checks.</p>

        <h5>Verification Process:</h5>

        <p>Our verification process includes, but is not limited to, document verification, background checks, and compliance with international sanctions lists. We do this to protect our clients and maintain the integrity of our business environment.</p>

        <p>If you fall into one of the categories above, please be aware that the verification process may be time-consuming, and approval is not guaranteed.</p>
We would like to highlight our Know Your Customer (KYC) policies, which are stringent and comply with international laws and regulations. Our commitment is to maintain a safe and transparent business environment for all our clients.

Who may face restrictions:
Politically Exposed Persons (PEPs): Given the sensitive nature and the potential risk of corruption associated with PEPs, it is challenging for our company to approve such individuals without rigorous and extensive checks.

Public Officials: Those serving in public roles, especially in positions that influence financial decisions, are subject to more stringent KYC scrutiny and may not be approved.

Individuals Convicted of Crimes: Particularly those convicted of trafficking, financial crimes, or other serious offenses are unlikely to be approved through our KYC process.

No Proof of Income: Clients who cannot provide adequate proof of income or the source of funds may also face difficulties in passing our KYC checks.

Verification Process:
Our verification process includes, but is not limited to, document verification, background checks, and compliance with international sanctions lists. We do this to protect our clients and maintain the integrity of our business environment.

If you fall into one of the categories above, please be aware that the verification process may be time-consuming, and approval is not guaranteed.
`,
      // lblWhyDidYouChooseDescription: `
      // Tax Benefits:

      // No Corporate Taxes:
      // There are no corporate taxes on profits, income, or capital gains for entities incorporated in the Bahamas but operating outside the jurisdiction.

      // No Withholding Taxes:
      // The Bahamas do not impose withholding taxes on dividends, interest, or royalties.

      // Confidentiality:
      // The Bahamas offer a certain level of confidentiality, making it more difficult for third parties to access information about the owners, directors, or shareholders of a company.

      // Regulatory Environment:

      // Flexible Legislation:
      // The Bahamas have modern and flexible corporate laws that are generally friendly to foreign investors.

      // Political Stability:
      // The Bahamas are known for their political stability, which can provide a sense of security for business owners.

      // Ease of Doing Business:

      // Minimal Reporting:
      // The Bahamas generally require less documentation and financial reporting compared to other jurisdictions.

      // Ease of Formation:
      // The incorporation process can be relatively quick and simple.

      // Professional Infrastructure:

      // Expertise:
      // There is a well-established community of legal and financial professionals in the Bahamas specializing in serving offshore entities.

      // Asset Protection:

      // Strong Protections:
      // Offshore companies and trusts in the Bahamas can offer robust asset protection features, making it difficult for foreign entities to seize assets or make claims against a Bahamas-based company.

      // No Exchange Controls:
      // For offshore entities, there are generally no exchange control regulations, allowing for the free movement of funds.
      // `,
      // lblWhyDidYouChooseDescriptionDelaware: `
      // Incorporate Your Business in Delaware: The Best Destination for Your LLC
      // Why Delaware is the ideal choice for your LLC
      // Delaware is the jurisdiction of choice for entrepreneurs, investors, and global companies. Its unique combination of tax benefits, legal protection, and operational ease makes it one of the most attractive states for forming a business in the United States.

      // Attractive Tax Benefits:
      // * No State Income Tax on Profits:
      // Delaware is a state that does not charge income or profit taxes on LLCs that operate outside the state. This means your company can generate revenue globally without worrying about additional state taxes.
      // * No Withholding Taxes:
      // Delaware does not impose withholding taxes on dividends, interest, or royalties paid out of the state, providing a highly efficient tax structure for businesses transacting with international clients and partners.

      // Confidentiality and Privacy:
      // * Owner Privacy Protection:
      // Delaware offers a significant level of privacy for LLC owners. There is no requirement to publicly disclose the names of the members or managers of the company, ensuring greater anonymity and personal protection.

      // Business-Friendly Regulatory Environment:
      // * Flexible, Business-Friendly Laws:
      // Delaware is famous for its highly adaptable business laws, designed to encourage growth and innovation. The state's legislation offers flexibility, making it easier for entrepreneurs to structure their businesses in the way that best suits them.
      // * Legal and Political Stability:
      // Delaware is one of the most stable states in the U.S., with a predictable and transparent legal system. Delaware's Court of Chancery, which specializes in business disputes, is widely respected and ensures that legal matters are resolved quickly and efficiently.

      // Ease of Operation:
      // * Fast and Simple Formation:
      // The process to register an LLC in Delaware is straightforward and quick. With the ability to complete incorporation in just one day, your business will be ready to operate smoothly and efficiently.
      // * Minimal Reporting and Affordable Costs:
      // Operating an LLC in Delaware is straightforward, with fewer bureaucratic requirements and minimal financial reporting compared to other states. Additionally, the annual franchise tax, while required, is affordable and significantly lower than in many other jurisdictions.

      // Asset Protection and Legal Security:
      // * Strong Protection for Members:
      // Delaware's legislation provides solid separation between the personal assets of members and the LLC's assets, offering an added layer of protection in the event of litigation. This makes Delaware an excellent choice for those seeking legal security and asset protection.
      // * No Restrictions on Fund Movement:
      // In Delaware, there are no restrictions on the movement of capital. This means you can freely transfer funds in and out of the state, making it easier to manage international operations and finances.

      // World-Class Professional Infrastructure:
      // * Business Expertise:
      // Delaware is home to a vast network of highly skilled professionals, such as lawyers, accountants, and financial consultants, who specialize in LLCs and other corporate structures. This support infrastructure ensures your business will have all the backing it needs to grow and thrive.

      // Conclusion:
      // Delaware offers everything you need to create and grow a successful business: exceptional tax benefits, robust legal protection, a business-friendly environment, and specialized support infrastructure. If you're looking for a jurisdiction that combines flexibility, security, and efficiency, Delaware is the right choice for your LLC.

      // Incorporate your business in Delaware today and take advantage of all the benefits the state has to offer for global companies.
      // `,

      lblWhyDirectors: `
        <h5>Director's Role</h5>
        <p>The directors of an offshore entity are responsible for overseeing the company's overall operations, ensuring that its activities comply with applicable laws and regulations. Their duties typically include setting strategic goals, approving internal policies, and working with executives and staff to ensure proper implementation. Directors must also safeguard the company's assets and act in the best interest of the entity.</p>

        <h5>KYC and Compliance Policies:</h5>
        <p>We would like to emphasize that our Know Your Customer (KYC) procedures are rigorous and fully aligned with international compliance standards. Our priority is to maintain a secure and transparent business environment for all clients.</p>

        <h5>Who May Face Restrictions:</h5>
        <p>Certain categories of individuals may be subject to enhanced due diligence or may not be approved during onboarding:</p>
        <ul>
          <li><strong>Politically Exposed Persons (PEPs):</strong> Due to the heightened risk associated with corruption or abuse of public office, PEPs require extensive background checks. Approval may be difficult and is not guaranteed.</li>
          <li><strong>Public Officials:</strong> Individuals holding public positions—especially those with influence over financial decisions—are subject to stricter KYC reviews and may be declined based on risk assessment.</li>
          <li><strong>Individuals with Criminal Convictions:</strong> Persons convicted of trafficking, financial crimes, fraud, or other serious offenses are unlikely to meet our compliance requirements.</li>
          <li><strong>No Proof of Income or Source of Funds:</strong> Applicants who cannot provide satisfactory proof of income or documentation evidencing the legitimate source of funds may face delays or non-approval.</li>
        </ul>

        <h5>Verification Process:</h5>
        <p>Our verification process includes, but is not limited to:</p>
        <ul style="list-style: disc; padding-left: 1.5rem; margin: 0.75rem 0 1rem;">
          <li style="margin-bottom: 0.35rem;">identity and document verification</li>
          <li style="margin-bottom: 0.35rem;">background and integrity checks</li>
          <li style="margin-bottom: 0.35rem;">review of international sanctions lists</li>
          <li>assessment of source of wealth and source of funds</li>
        </ul>
        <p>These measures ensure the protection of all clients and uphold the integrity of our corporate ecosystem.</p>

        <h5>Important Notice:</h5>
        <p>If you fall into any of the categories listed above, please be aware that the verification process may take longer than expected, and approval cannot be guaranteed.</p>
      `,

      lblWhyDidYouChooseDescription: `
        <h5>1. Tax Benefits</h5>
        <p><strong>No corporate tax:</strong> Entities registered in The Bahamas but operating outside the country are not subject to corporate income tax, personal income tax, or capital gains tax.</p>
        <p><strong>No withholding tax:</strong> Dividends, interest, and royalties paid abroad are not subject to withholding tax.</p>
        <p><strong>Territorial tax system:</strong> Only activities conducted within The Bahamas are taxed, which is advantageous for structures with international operations.</p>
        <h5>2. Confidentiality</h5>
        <p><strong> Reasonable information protection:</strong> Although The Bahamas complies with international transparency standards, information on directors and shareholders is not publicly accessible, providing an appropriate level of corporate privacy.</p>
        <h5>3. Favorable Regulatory Environment</h5>
        <p><strong>Modern and flexible legislation:</strong> The corporate legal framework is stable, up-to-date, and investor-friendly.</p>
        <p><strong>Political and legal stability:</strong> The Bahamas is known for strong institutional stability, offering greater security to owners and beneficiaries.</p>
        <h5>4. Ease of Doing Business</h5>
        <p><strong>Low reporting requirements:</strong> Maintenance and reporting obligations are simpler than in many other jurisdictions.</p>
        <p><strong>Fast incorporation:</strong> The incorporation process can be completed within a few days, with clear and efficient procedures.</p>
        <h5>5. Professional Infrastructure</h5>
        <p><strong>Experienced specialists:</strong> The country has a well-established network of lawyers, accountants, and corporate service providers with deep expertise in offshore structures.</p>
        <h5>6. Asset Protection</h5>
        <p><strong>Strong tools:</strong> Bahamian corporate structures and trusts provide effective planning mechanisms for asset protection, making it more difficult for foreign entities to seize assets without due legal process.</p>
        <p><strong>No exchange controls:</strong> There are no significant restrictions on the international movement of funds for offshore entities.</p>
      `,

      lblWhyDidYouChooseDescriptionDelaware: `
        <h5>Incorporate Your Business in Delaware: The Best Destination for Your LLC</h5>

        <p><strong>Why Delaware is the ideal choice for your LLC</strong></p>

        <p>Delaware is the jurisdiction of choice for entrepreneurs, investors, and global companies. Its unique combination of tax benefits, legal protection, and operational ease makes it one of the most attractive states for forming a business in the United States.</p>

        <h5>Attractive Tax Benefits:</h5>
        <ul>
          <li><strong>No State Income Tax on Profits:</strong> Delaware does not charge income or profit taxes on LLCs that operate outside the state.</li>
          <li><strong>No Withholding Taxes:</strong> No withholding taxes on dividends, interest, or royalties paid out of the state.</li>
        </ul>

        <h5>Confidentiality and Privacy:</h5>
        <ul>
          <li><strong>Owner Privacy Protection:</strong> No requirement to publicly disclose the names of members or managers.</li>
        </ul>

        <h5>Business-Friendly Regulatory Environment:</h5>
        <ul>
          <li><strong>Flexible, Business-Friendly Laws:</strong> Delaware's legislation is highly adaptable, encouraging growth and innovation.</li>
          <li><strong>Legal and Political Stability:</strong> The Court of Chancery ensures predictable and efficient resolution of business disputes.</li>
        </ul>

        <h5>Ease of Operation:</h5>
        <ul>
          <li><strong>Fast and Simple Formation:</strong> The LLC registration process can be completed in just one day.</li>
          <li><strong>Minimal Reporting and Affordable Costs:</strong> Low bureaucracy and an accessible annual franchise tax.</li>
        </ul>

        <h5>Asset Protection and Legal Security:</h5>
        <ul>
          <li><strong>Strong Protection for Members:</strong> Clear separation between personal and LLC assets, providing legal and financial protection.</li>
          <li><strong>No Restrictions on Fund Movement:</strong> Capital can be freely transferred in and out of the state.</li>
        </ul>

        <h5>World-Class Professional Infrastructure:</h5>
        <ul>
          <li><strong>Business Expertise:</strong> Delaware has a strong network of lawyers, accountants, and consultants specialized in LLCs and corporate structures.</li>
        </ul>

        <h5>Conclusion:</h5>

        <p>Delaware offers everything you need to create and grow a successful business: exceptional tax benefits, robust legal protection, a business-friendly environment, and specialized support infrastructure.</p>

        <p><strong>If you're looking for a jurisdiction that combines flexibility, security, and efficiency, Delaware is the right choice for your LLC.</strong></p>

        <p>Incorporate your business in Delaware today and take advantage of all the benefits the state has to offer for global companies.</p>
      `,

      lblInstructionForBecause:
        'This information is provided as guidance for clients, as we assist more than 1,000 users in setting up offshore companies in this jurisdiction.',
      lblIncorpIn: 'Incorporate in the',
      lblIncorp: 'Incorporate in',
      lblSelectAddons: 'Select your addons',
      lblBilling: 'Billings & Payments',
      lblAnnualRenewal: 'Annual Renewal',
      lblAnnualFee: 'Annual Fee',
      lblWhatIsAnnualFee: 'What is the Annual Fee?',
      lblAnnualFeeIncludes: 'The Annual Fee Includes:',
      lblAnnualFeeInclude1: 'Company registration maintenance',
      lblAnnualFeeInclude2: 'Company Documentation Support',
      lblAnnualFeeInclude3: 'Regulatory compliance',
      lblAnnualFeeInclude4: 'Administrative support',
      lblWhyAnnualFeeImportant: 'Why is the Annual Fee Important?',
      lblCompliance: 'Compliance',
      lblLegalStatus: 'Legal Status',
      lblBusinessContinuity: 'Business Continuity',
      lblReadyToProceed: 'Ready to Proceed',
      lblPrefereces: 'Preferences',
      lblPreferences: 'Preferences',
      lblEnvironmentSetup: 'Environment Setup',
      lblPaymentStatus: 'Payment Status',
      lblEnquiry: 'Enquiry',
      lblAddon: 'Add-on',
      lblRepeatPassWord: 'Repeat your password',
      lblCardholderName: 'Cardholder Name *',
      lblExpiration: 'Expiration',
      lblCardNumber: 'Card Number',
      lblDebitCard: 'Debit Card',
      lblPaymentDetails: 'Payment Details',
      lblPayYourRequest: 'Pay your request',
      lblShareholder: 'Shareholder',
      lblMembers: 'Members',
      lblUploadCertificates: 'Upload Company Documents',
      // Upload individual de documentos
      selectFileFirst: 'Please select a file first',
      selectDateFirst: 'Please select an issue date first',
      uploaded: 'Uploaded',
      download: 'Download',
      documentUploadedOn: 'Uploaded on',
      fileName: 'File',
      fileSelected: 'File selected',
      moreFiles: 'more files',
      uploading: 'Uploading...',
      uploadThisDocument: 'Upload This Document',
      documentAlreadyUploaded: 'Document already uploaded',
      uploadStatus: 'Upload Status',
      documentsUploaded: 'documents uploaded',
      requiredDocumentsUploaded: 'required documents uploaded',
      allRequiredDocumentsUploaded: 'All required documents uploaded',
      readyToApprove: 'Ready to approve company',
      sealCopyNotRequired: 'This document is not required for approval',
      uploadRemaining: 'Upload Remaining Documents',
      noFilesSelected: 'No files selected for remaining documents',
      allDocumentsUploaded: 'All documents have been uploaded',
      documentUploadedSuccessfully: 'Document uploaded successfully',
      // Status de documentos
      approved: 'Approved',
      pending: 'Pending',
      rejected: 'Rejected',
      notUploaded: 'Not Uploaded',
      // Upload de documentos específicos
      uploadDocument: 'Upload Document',
      uploadAddress: 'Upload Address',
      uploadDocumentDescription: 'Upload a document for this shareholder',
      uploadPassportDescription: 'Upload a passport for this shareholder',
      uploadAddressDescription: 'Upload an address document for this shareholder',
      registrationCompleted: 'Registration Completed',
      documentSuccessfullyUploaded: 'Document successfully uploaded',
      uploadNewVersion: 'Upload New Version',
      clickToUploadNewVersion: 'Click to upload a new version',
      uploadedDocuments: 'Uploaded Documents',
      sending: 'Sending...',
      sendRegistrationData: 'Send Registration Data',
      registrationStatus: 'Registration Status',
      completed: 'Completed',
      lblInputFirstMessage: 'Input the first message',
      lblMyFirstMessageIs: 'My first message is...',
      lblSendMessage: 'Send a message',
      lblReasonForMoreInfo: 'Reason for more info',
      lblCompanyInfo: 'Company Information',
      lblMailroom: 'Mailroom',
      lblContactUs: 'Contact Us',
      lblRegistrationNo: 'Registration No',
      lblNoRegistrationNumber: 'No Registration Number',
      lblCompanyStatus: 'Company Status',
      lblIncorporationDate: 'Incorporation Date',
      lblViewMore: 'View more',
      lblCompanyDocuments: 'Company Documents',
      lblNoDocuments: "You don't have documents",
      lblNoNotifications: "You don't have notifications",
      lblNoNameDocument: 'Untitled Document',
      lblPdfDocument: 'PDF Document',
      lblSubscriberType: 'Type of Signer',
      lblSubscriberName: 'Name of Signer',
      lblDocumentationStatus: 'Documentation Status',
      lblDocument: 'Document',
      lblAnalyzeDocuments: 'View Documents',
      lblDirectorsAndShareholders: 'Directors and Shareholders',
      lblCompanySecretary: 'Company Secretary',
      lblAccounting: 'Accounting',
      lblRequests: 'Requests',
      lblOnGoing: 'On-Going',
      lblCompanyDetails: 'Company Details',
      lblCompanyLogo: 'Company logo',
      lblCompanyLogoDescription: 'Add an image for your company identity on the platform',
      lblChangeLogo: 'Change logo',
      lblShowLogoInMenu: 'Show in the menu',
      lblClickToSelect: 'Click to select',
      lblOrDragImageHere: 'or drop an image here',
      lblLogoRecommendations: 'A horizontal image works best, such as 1000x300',
      lblLogoFormats: 'JPG or PNG',
      lblLogoSizeLimit: 'Maximum 5MB',
      lblUploadingLogo: 'Uploading logo...',
      lblLogoUpdatedSuccess: 'Company logo updated',
      lblUploadError: 'Could not upload the logo',
      lblUnsupportedFileFormat: 'Unsupported format. Use JPG or PNG',
      lblFileTooLarge: 'File is too large. Maximum size is 5MB',
      lblCompanyNotApproved: 'The logo can be uploaded after the company is approved',
      lblCompanyName: 'Your company',
      lblFinancialYear: 'Financial Year',
      lblAddress1: 'Address 1 *',
      lblAddress2: 'Address 2',
      lblPostalCode: 'Postal Code *',
      lblCity: 'City *',
      lblState: 'State *',
      lblNeighborhood: 'Neighborhood *',
      lblCountry: 'Country',
      lblEconomicSubstance: 'Economic Substance',
      lblPrincipalActivity: 'Primary activity',
      lblMainActivities: 'Main activities',
      lblSecondaryActivity: 'Secondary Activity',
      lblShareName: 'Share Name',
      lblTotalPaidUpCapital: 'Total Paid-Up Capital',
      lblTotalIssuedShareCapital: 'Total Issued Share Capital',
      lblTotalNumberOfShares: 'Total Number of Shares',
      lblSelectChat: 'Select a Chat to see new messages',
      lblSearchPeople: 'Search user',
      lblTypeHere: 'Type here...',
      lblSearchCompany: 'Search company...',
      lblSearchEmail: 'Search email...',
      lblGeneralDocuments: 'General documents',
      lblDocumentName: 'Document Name',
      lblMessageStatus: 'Message',
      lblView: 'View',
      lblType: 'Type',
      lblRole: 'Role',
      lblDatePosted: 'Posting Date',
      lblStatus: 'Status',
      lblActions: 'Actions',
      lblID: 'ID',
      lblTotalDocuments: 'Total Documents',
      lblInputInformationDirectors: 'Please provide the information of the director',
      lblDirector: 'Director',
      lblPendingUploadFile: 'Pending Upload File',
      lblCompleted: 'Completed',
      lblDirectorShareholder: 'Director/Shareholder',
      lblNoDataAvailable: 'No data available',
      lblNoDirectorsOrShareholders: 'No directors or shareholders registered yet.',
      lblTransferCompany: 'Transfer Company',
      lblPage: 'Page',
      lblNextPage: 'Next',
      lblPevPage: 'Prev',
      lblToNextPage: 'In',
      lblGender: 'Gender *',
      lblGenderMale: 'Male',
      lblGenderFemale: 'Female',
      lblDateOfBirth: 'Date of Birth (yyyy/mm/dd)*',
      lblPhone: 'Phone*',
      lblPhoneLess: 'Phone',
      lblNationality: 'Country of Birth *',
      lblPassportNo: 'Passport No*',
      lblExpiryDate: 'Expiry Date (yyyy/mm/dd)*',
      lblPassportIssuingCountry: 'Passport Issuing Country*',
      lblIssueDate: 'Issue Date (yyyy/mm/dd)*',
      lblIssueDateLess: 'Issue Date',
      lblUploadDirectorsDocuments: 'Upload director\'s documents',
      lblUploadShareholdersDocuments: 'Upload shareholder\'s documents',
      lblUploadMembersDocuments: 'Upload member\'s documents',
      lblPassport: 'Passport',
      // Passport Upload Modal
      passportExpired: 'Passport Expired',
      expiresIn: 'Expires in',
      days: 'days',
      valid: 'Valid',
      email: 'Email',
      passportNo: 'Passport No',
      passportExpiry: 'Passport Expiry',
      datePosted: 'Posting Date',
      uploadNewPassport: 'Upload New Passport',
      renewPassport: 'Renew Passport',
      unnamed: 'Unnamed',
      noEmail: 'No email',
      noPassport: 'No passport',
      unknown: 'Unknown',
      noDirectorsOrShareholders: 'No Directors or Shareholders',
      noDirectorsOrShareholdersAdded: 'No directors or shareholders have been added yet.',
      // Passport Upload Modal
      passportUploadTitle: 'Upload New Passport',
      passportUploadDescription: 'Upload a new passport document for {{name}}.',
      uploadPassportDocument: 'Upload Passport Document',
      uploadPassportDocumentDescription: 'Upload your passport document',
      documentUpload: 'Document Upload',
      passportInformation: 'Passport Information',
      passportNumber: 'Passport Number',
      expiryDate: 'Expiry Date',
      issueDate: 'Issue Date',
      passportIssuingCountry: 'Passport Issuing Country',
      selectCountry: 'Select a country',
      passportDocument: 'Passport Document',
      uploadYourDocument: 'Upload your document',
      orSearchInComputer: 'or search in your computer',
      supportedFormats: 'Supported formats: PDF or DOC | Maximum size: 3MB',
      uploadPassport: 'Upload Passport',
      passportUpdatedSuccessfully: 'Passport updated successfully',
      passportNumberRequired: 'Passport number is required',
      issuingCountryRequired: 'Issuing country is required',
      issueDateRequired: 'Issue date is required',
      passportFileRequired: 'Passport file is required',
      lblLocalDocument: 'National ID',
      lblProveAddress: 'Proof of Residence',
      lblPersonalDocuments: 'Personal Documents',
      lblNoCompanyDocumentsDescription: 'No company documents have been submitted yet.',
      lblSigned: 'Signed',
      lblUnsigned: 'Unsigned',
      lblNextStep: 'Next Step',
      lblPushYourDocument: 'Push your document',
      lblClickToUpload: 'Click to upload',
      lblUpload: 'Upload',
      lblSuccessYourDocument: 'Document sent successfully',
      lblOrSearchInYourComputer: 'or search in your computer',
      lblDocumentsSupported: 'documents supported: PDF or DOC | Maxime size: 30MB',
      lblDocumentsSupportedEnquiry: 'Documents supported: IMG or PDF | Maxime size: 5MB',
      lblInputInformationShareholders: 'Please provide Shareholder information',
      lblInputInformationMembers: 'Please provide Members information',
      lblShareDetails: 'Share Details',
      lblShareIssuanceDate: 'Share Issuance Date (yyyy/mm/dd)*',
      lblClassOfShares: 'Class of Shares',
      lblSelectClassShare: 'Select a class share',
      lblSeriesOfShares: 'Series of Shares*',
      lblPrivilegesRestrictions: 'Privileges/Restrictions (if any)',
      lblConditions: 'Conditions (if any)',
      lblRequestsBar: 'Requests',
      lblTypeDocuments: 'Type',
      lblWeveHelped: "We've helped 1000+ customers to open offshores",
      lblAdditionalSelect: 'Select your Jurisdiction',
      lblBackToHomePage: 'Go to Homepage',
      lblAdminModeSkipPayment: 'Admin mode: skip payment',
      lblSelectYourCompany: 'Select your company',
      lblSelect: 'Select',
      lblSelectType: 'Select Type',
      lblReset: 'Reset',
      lblPrimaryColor: 'Main Colors',
      lblButtonColor: 'Button Colors',
      lblBorderColor: 'Border Colors',

      lblExactDateFilter: 'Search by exact date',
      lblExactDate: 'Exact date',
      activeFilters: 'Active Filters',
      resultsFound: 'results found',
      lblDueDate: 'Due Date',
      lblAmount: 'Amount',
      lblStartingFrom: 'Starting from',
      lblNoCompanyName: 'No company name defined',
      lblCorporateDirector: 'Corporate Director',
      lblIncluded: 'Included',
      lblRenewalAddonsTitle: 'Add extra services to your renewal',
      lblRenewalAddonsDescription: 'Since you are renewing, you can also add extra services or features to your company. These are optional and can be changed later.',
      annualFeeIntroText: 'In the next steps, you’ll be able to review your offshore company details and optionally select addons that add value to your business.\nAt the end, you’ll proceed to pay the annual fee according to your company’s jurisdiction.\nLet’s get started!',
      cancel: 'Cancel',
      clickToChangeFile: 'Click to change file',
      
      // Director/Shareholder Dashboard
      lblMyProfile: 'My Profile',
      lblViewAndEdit: 'View and edit your information',
      lblProfileComplete: 'Profile Complete',
      lblViewProfile: 'View Profile',
      lblMyDocuments: 'My Documents',
      lblDocumentStatus: 'Check your document status',
      lblSubmitted: 'Documents Submitted',
      lblComingSoon: 'Coming Soon',
      lblYourCurrentStatus: 'Your current status',
      lblActive: 'Active',
      lblViewYourDocuments: 'View Documents',
      lblNoDocumentsDescription: "You haven't submitted any documents yet.",
      lblDocuments: 'documents',
      lblUntitledDocument: 'Untitled Document',
      lblUploadedOn: 'Uploaded on',
      lblDownload: 'Download',
      lblApproved: 'Approved',
      lblRejected: 'Rejected',
      lblPending: 'Pending',
      lblPassports: 'Passports',
      lblIssuingCountry: 'Issuing Country',
      lblAddressDocuments: 'Address Documents',
      lblAddressProof: 'Address Proof',
      lblDocumentsInfo: 'Documents are reviewed by our team. You will be notified once the review is complete.',
      lblNoCompanyLinked: 'No Company Linked',
      lblNoCompanyLinkedDescription: 'You are not currently linked to any company. Please contact support if you believe this is an error.',
      lblAboutDirectorDashboard: 'About Director/Shareholder Dashboard',
      lblDirectorDashboard: 'Director/Shareholder Dashboard',
      lblDirectorDashboardDescription: 'This dashboard allows you to view and manage your personal information as a director or shareholder. You can update your details, view your documents, and track your status.',
      lblRecentUpdates: 'Recent updates',
      lblAllCaughtUp: 'You\'re all caught up!',
      lblViewAll: 'View All',
      
      // Profile Page
      lblManageYourPersonalInfo: 'Manage your personal information',
      lblEdit: 'Edit',
      lblSave: 'Save',
      lblSaving: 'Saving...',
      lblPersonalInformation: 'Personal Information',
      lblBirthDate: 'Birth Date',
      lblAddress: 'Address',
      lblStreet: 'Street',
      lblZipCode: 'Zip Code',
      lblOfficialDocuments: 'Official Documents',
      lblPassportNumber: 'Passport Number',
      lblTaxId: 'Tax ID',
      lblClickEditToUpdate: 'Click "Edit" button to update your information'
    },

    // Campos
    fields: {
      fldConfirmPwdPlaceholder: 'Example: 12345#!2',
      fldEmailPlaceholder: 'Example: Ariel@offshore2go.com',
      fldLastNamePlaceholder: 'Example: Souza',
      fldFirstNamePlaceholder: 'Example: Ariel',
      fldPronounPlaceholder: 'Select your pronoun',
      fldSelectYourOption: 'Select your option',
      fldPwdPlaceholder: 'Example: 12345#!2',
      fldFieldNumber: 'The field must be a number',
      fldOnboarding: 'Onboarding'
    },

    // Titles
    titles: {
      ttlResetPwd: 'Reset your password',
      ttlCreateAccount: 'Create your account',
      ttlDefineObjectives: 'Select your main goals',
      ttlChooseObjectives: 'What is your main goal?',
      ttlCreateNewOffshore: 'I want to create a new Offshore',
      ttlTransferExistingOffshore: 'I want to register an existing Offshore',
      ttlSummary: 'Summary of your purchase',
      ttlOffshorePackage: 'Your Offshore2Go Package',
      ttlDirectorsCount: 'How many directors will your offshore company have?',
      ttlJurisdiction: 'Define your jurisdiction',
      ttlAddons: 'Please select the addons',
      ttlShareholderCount: 'How many shareholders will your offshore have?',
      ttlShareholderUnderagesCount: 'How many of these shareholders are underage?',
      ttlMembersCount: 'How many members will your offshore have?',
      ttlMembersUnderagesCount: 'How many members?',
      ttlMinorsCount: 'How many are minors?',
      ttlConfirmation: 'Your confirmation',
      ttlNotFound: 'Page not found',
      ttlInstructionCardTitle: 'Instruction for you',
      ttlFinishRegister: 'Finish your register',
      ttlButtonInformation:
        'You need to sign the user agreement. If you have already signed the document, wait a few moments and refresh the page again.',
      ttlSigned: 'Signed',
      ttlAlertContract:
        "Before we proceed with your registration, we need you to sign the Offshore2go user contract. By clicking on the button below you'll be redirected to our partner Forsign website where you can sign the contract online very quickly. In case you already signed the contract, please wait or try refreshing this web page.",
      ttlSignTheContract: 'Download Documents',
      ttlDownload: 'Download',
      ttlDownloadDocument: 'Download document',
      ttlVerifySignatures: 'Verify signatures',
      ttlButtonSignTheContract: 'You must sign the user contract before finishing your register.',
      ttlButtonSignTheContractNew: 'Sign contract',
      ttlButtonDownloadCertificated: 'Download your certificate',
      ttlttlButtonDownloadCertificatedHover:
        'You will be able to download your certificate once your company is approved.',
      ttlButtonDownloadCertificatedIncorporation: 'Download Certificate incorporation',
      ttlHello: 'Hello',
      ttlWelcome: 'Welcome',
      ttlSelectCompany: 'Select company',
      ttlHome: 'Home',
      ttlSubTituloInitial: 'INITIAL',
      ttlCompany: 'COMPANY',
      ttlConfig: 'SETTINGS',
      ttlEditPassWord: 'Edit your Password',
      ttlEnquiryPage: 'What can we help with?',
      ttlEnquirySelect: 'Subject',
      ttlEnquiryMessage: 'Message',
      ttlEnquiryAttachment: 'Attachment',
      ttlThereNoRecords: 'There are no records yet.',
      ttlCustomizeMyPlatform: 'Customize my platform',
      ttlBasicConfig: 'Basic Configuration',
      ttlTooltipFormatImg: 'Attention: The Offshore2go logo should be 798x155 pixels in size for optimal display. Allowed formats: PNG, JPG, JPEG, and SVG.',
      ttlCLickOrDropDocuments: 'Click or drag files to upload',
      ttlAnnualFeeIntro: "Welcome to your company's annual renewal process!",
      annualFeeIntroText: "In the next steps, you'll be able to review your offshore company details and optionally select addons that add value to your business.\n At the end, you'll proceed to pay the annual fee according to your company's jurisdiction.\nLet's get started!",
      lblRenewalAddonsTitle: 'Add extra services to your renewal',
      lblRenewalAddonsDescription: 'Since you are renewing, you can also add extra services or features to your company. These are optional and can be changed later.',
      lblNoCompanyName: 'No company name defined'
    },

    descriptions: {
      PageAddonsDescription: "Don't worry, you may change your preferences at any time",
      Directors: 'Directors',
      CorporateDirector: 'Corporate Director',
      Shareholder: 'Shareholder',
      OperationalCompany: 'Operational Company',
      Startup: 'Startup',
      CommingSoon: 'Coming Soon',
      ServicesDays: 'Days',
      Members: 'Members',
      renewalAddonsDescription: 'Since you are renewing, you can also add extra services or features to your company. These are optional and can be changed later.',
      annualFeeIntroText: 'In the next steps, you’ll be able to review your offshore company details and optionally select addons that add value to your business.\nAt the end, you’ll proceed to pay the annual fee according to your company’s jurisdiction.\nLet’s get started!'
    },

    config: {
      TabFees: 'Standard Fees',
      TabAddons: 'Addons',
      TabDirectors: 'Directors & Shareholders',
      TabJurisdictions: 'Jurisdictions',
      TargetJuridiction: 'Target Jurisdiction',
      ColorPrimary: 'Primary',
      ColorSecondary: 'Secondary',
      ColorTertiary: 'Tertiary',
      Logo: 'LogoType',
      UploadImageFile: 'Upload image file',
      Active: 'Active',
      DirectorFee: 'Director Fee',
      ShareholdersFee: 'Shareholder Fee',
      CorporateDirectorFee: 'Corporate Director Fee',
      tooltipDirectorFee: 'Fee charged per individual director appointed to the company. This is the amount the client pays for each natural person acting as director.',
      tooltipCorporateDirectorFee: 'Fee for appointing a corporate director (a company acting as director). Often used for structure or nominee services.',
      tooltipShareholdersFee: 'Fee charged per shareholder. This is the amount the client pays for each person or entity that holds shares in the company.'
    },
    environment: {
      manageAddons: 'Manage Add-ons',
      styleSaved: 'Style saved',
      removeImage: 'Remove image',
      logoPreview: 'Logo preview',
      selectColor: 'Select color',
      errorSavingFees: 'Error saving fees.',
      noChangesToSave: 'No changes to save.',
      errorSavingAddons: 'Error saving add-ons.',
      errorUpdatingJurisdiction: 'Error updating jurisdiction.',
      jurisdictionUpdatedSuccess: 'Jurisdictions updated successfully.',
      addonsUpdatedSuccess: 'Add-ons updated successfully!',
      stylesUpdatedSuccess: 'Styles updated successfully.',
      logoUploadedSuccess: 'Logo uploaded successfully!',
      feesUpdatedSuccess: 'Fees updated successfully.',
      userNotAuthenticated: 'User not authenticated.',
      errorFetchingAddons: 'Error fetching add-ons.',
      errorUpdatingFee: 'Error updating fee.',
      errorFetchingPlanInfo: 'Error fetching plan information.',
      errorFetchingDirectorsShareholdersConfig: 'Error fetching directors/shareholders config.'
    },

    // Messages
    messages: {
      msgCompanyAproved: 'Company successfully completed and approved',
      msgFileSizeError: 'The file must be a maximum of 3MB',
      registrationDataSent: 'Registration data sent successfully',
      profileUpdatedSuccessfully: 'Profile updated successfully',
      errorUpdatingProfile: 'Error updating profile. Please try again.',
      errorLoadingDocuments: 'Error loading documents. Please try again.',
      errorLoadingCompanies: 'Error loading companies. Please try again.',
      passwordChangedSuccessfully: 'Password changed successfully',
      errorLoadingProfile: 'Error loading profile data. Please try again.',
      msgDirectorsInstruction:
        'Our 25 years of experience team has helped 1,000+ users to set up offshore companies in Bahamas, Cayman, Belize and Delaware, among other jurisdictions.',
      msgShareholdersInstruction:
        'Our 25 years of experience team has helped 1,000+ users to set up offshore companies in Bahamas, Cayman, Belize and Delaware, among other jurisdictions.',
      msgConfirmInstruction:
        'Our 25 years of experience team has helped 1,000+ users to set up offshore companies in Bahamas, Cayman, Belize and Delaware, among other jurisdictions.',
      filterActive: 'Filter active',
      noAddonsAvailable: 'No add-ons available for this item.',
      annualRenewalIntro: 'Learn about the annual fee and understand why keeping your company in good standing is essential.',
      annualFeeDescription: 'The annual fee is a mandatory payment that must be made annually to keep your offshore company active and compliant with local regulations.',
      annualFeeBenefits: 'This fee ensures that your company maintains its legal status and continues operating without interruptions.',
      complianceDescription: 'Keeps your company compliant with the laws and regulations of the jurisdiction.',
      legalStatusDescription: 'Preserves the legal status of your company and avoids penalties.',
      businessContinuityDescription: 'Ensures your operations continue without interruptions.',
      proceedDescription: 'You can now proceed to see the details of your annual fee and select additional services.',
      showingResults: 'Showing',
      results: 'results',
      showingRange: 'Showing {{from}} - {{to}} of {{total}} results',
      pageInfo: 'Page {{current}} of {{last}}',
      documentUploadedSuccessfully: 'Document uploaded successfully'
    },

    // Validations
    validations: {
      valRequired: 'Complete this field',
      required: 'This field is required',
      valPwdRule: 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
      valPwdAdvice:
        'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
      valInvalidEmail: 'Email invalid.',
      valPwdMustMatch: 'Passwords must match',
      valEmailValid: 'You must provide a valid email',
      valFileTypeError: 'The file must be a PDF or DOCX',
      valObjectivesRequired: 'At least 1 objective must be selected',
      valMustbeNumber: 'Number of shareholders is required',
      valNumberShareholders: 'Number of underage must be less than shareholders',
      valMustZero: 'must be greater than zero',
      valAttetion: 'Attention',
      valStayTuned: 'Coming soon!! Stay tuned!',
      valUnoDirector: 'At least 1 director must be selected',
      valMaxDirectors: 'The maximum number of directors is 8',
      valUnoShareholder: 'At least one shareholder must be selected',
      valMaxShareholders: 'The maximum number of shareholders is 8',
      valTitleNotificion: 'Notifications',
      valSubtituloNotificacion: 'No notifications',
      valReadAll: 'Read all',
      valExpiryDate: 'Invalid expiration date. Minimum time of 6 months from today.',
      valIncorporationDateMinDate: 'Incorporation date must not be less than 1 week',
      valMinAge: 'You must be at least 18 years older',
      valInvalidDate: 'Invalid date format',
      valEnquirySelect: 'Enquiry is required',
      valEnquiryMessage: 'Message is required',
      valEnquiryMaxMessage: 'Description cannot be longer than 100 characters',
      valRequiredJurisdictionStructure: 'A company type must be selected',
      valRequiredJurisdictions: 'At least one jurisdiction must be selected',
      valFieldsEmpty: 'Mandatory fields are empty.',
      valValidationFailed: 'Validation failed.'
    },

    errorMessage: {
      errMessAddRequest:
        'This service request is already open for this company, please check the On-Going tab to check the status',
      errMessStepRegisterShareholders: 'All Shareholders have not yet been registered.',
      errMessStepRegisterDirectors: 'All Directors have not yet been registered.',
      errMessStepRegisterMembers: 'All Members have not yet been registered.',
      errMessUnexpected: 'An unexpected error occurred. Please try again.'
    },

    buttons: {
      btnBack: 'Back',
      btnRegister: 'Register',
      btnSave: 'Save',
      btnNext: 'Next Step',
      btnSendMessage: 'Send a message',
      btnSending: 'Sending...',
      btnEdit: 'Edit',
      btnResetPwd: 'Reset password',
      btnLogin: 'Login',
      btnContinueToCheckout: 'Continue to checkout',
      btnIgnoredCheckout: 'Skip payment',
      btnGoToDashboard: 'Go to dashboard',
      btnGoBack: 'Go back',
      btnLogOut: 'LogOut',
      btnResetPassWord: 'Reset Password'
    },

    documents: {
      proofOfAddress: 'Proof of Address',
      passport: 'Passport',
      localDocument: 'Local Document (National ID)',
      passportExpired: 'Passport expired ({{days}} days ago)',
      passportNearExpiry: 'Expires in {{days}} days',
      passportValid: 'Passport valid (expires in {{days}} days)',
      passportExpiry: 'Expiry: {{date}}',
      uploadPassport: 'Upload passport'
    },

    actions: {
      retry: 'Retry',
      refresh: 'Refresh',
      clearFilters: 'Clear Filters',
      markAsPaid: 'Mark as Paid',
      generateInvoice: 'Generate Invoice',
      close: 'Close',
      removeFilter: 'Remove filter'
    },

    errors: {
      fetchBillingsFailed: 'Failed to fetch billing data',
      rateLimitExceeded: 'Too many requests at the moment. Please wait a few seconds and try again. If the problem persists, reload the page.',
      invalidUserIdentification: 'Invalid user identification'
    },

    statuses: {
      paid: 'Paid',
      pending: 'Pending',
      overdue: 'Overdue'
    },

    tooltips: {
      tltMinor: 'Number of minors you want',
      tltDirector:
        'Please specify the number of directors you intend to appoint. Even if you plan to hire an outsourced director, you can still appoint your own directors.',
      tltShareholder: 'Report the total number of shareholders.',
      tltShareholderMembers: 'Report the total number of members.',
      tltLegalPersonality: 'We will offer a suggested structure that may meet your needs.',
      tltTotalValue:
        'All charges will be made in US dollars. Please consult your credit card issuer for further information on exchange rates and applicable fees.',
      tltJurisdictions: 'Select the jurisdiction of your choice on the list below.',
      corporateDirectorDescription: 'Include a corporate director in your company\'s annual renewal.'
    },

    // Others
    others: {
      othCompanyName: 'Company Name',
      othPreferredName: 'Preferred name',
      othSecondaryName: 'Secondary name',
      othOption1: 'Option 1',
      othOption2: 'Option 2',
      othOption3: 'Option 3',
      othNameOptions: 'Name options',
      othNoAccount: "Don't have an account?",
      othForgotPwd: 'Forgot password?',
      othResetPwdInstruction: 'Enter your email to receive password reset instructions.',
      othChangePassword: 'Change Password',
      othChangePasswordDescription: 'Please enter your new password below.',
      othProcessing: 'Processing...',
      othPasswordChangedSuccess: 'Password successfully changed!',
      othHireCorpDirector: 'I want to hire a Corporate director',
      othOrText: 'or',
      othPaymentSuccess: 'Payment made successfully!',
      othPaymentFailed: '¡Error al realizar el pago! Vuelve a intentarlo más tarde.',
      othRegistering: 'Registering',
      othCompanies: 'Companies',
      otheNewCompany: 'New Companies',
      otheTransferredCompanies: 'Transferred Companies',
      othCompany: 'Company',
      othDirectors: 'Director',
      othShareholders: 'Shareholder',
      otheShareholdersAndDirectors: 'Directors and Shareholders',
      othCompanyDocuments: 'Company Documents',
      othBusiness: 'Businness',
      othInformationYourNewCompany: 'New Company Information',
      othIBCPrimaryNameTooltip: `
      Please note that your preferred company name may not always be available, as the exact name or a very similar variation may already be in use by another entity. Therefore, make sure to indicate your preferred name and two alternative options below, in order of preference.The company name must end with “Limited” or “Ltd.”, so please ensure that your preferred ending is included in each of your name choices.Please also note that your company will be incorporated using the name exactly as provided below. For this reason, enter the name exactly as you wish it to appear on your corporate documents.
      `,
      othIBCPrimaryName: 'First Name Option*',
      othIBCSecondName: 'Second Name Option*',
      othIBCThirdName: 'Third Name Option*',
      othActivityAddress: 'Main director address *',
      othMainCommercialAddress: 'Main Commercial Address *',
      othPrimaryPhone: 'Primary Phone *',
      othPrimaryEmail: 'Primary E-mail *',
      othManagerAddress: 'First Manager Address *',
      othNumberOfUnits: 'Number of Units',
      othNumberOfUnitsTooltip:
        'Membership units are pieces of ownership in an LLC, similar to shares of stock in a corporation. The number of units must be in a 1 to 50,000 range.',
      othNumberOfSharesTooltip:
        'Shares represent ownership in the company. Enter how many shares this shareholder holds. The number of shares must be in a 1 to 50,000 range.',
      othMaxSharesUnits: 'The maximum limit is 50,000.',
      othCreationDate: 'Creation date',
      othDoesTheCompanyConductRelevantActivities: 'Does the company conduct relevant activities?*',
      othRelevantActivities: 'Relevant Activities',
      othNo: 'No',
      othYes: 'Yes',
      othChooseRelevantActivity: 'Choose relevant activity *',
      othRelevantActivity: 'Relevant activity',
      othChooseRelevantActivityTooltip:
        'Please choose from the options below, the one that suits best the purpose of your offshore',
      othShareCapital: 'Share Capital',
      othShareCapitalLess: 'Share Capital',
      othSelectRelevantActivity: 'Select a relevant activity',
      othTotalAuthorizedShares: 'Total Authorized Shares',
      othTotalAuthorizedSharesTooltip:
        'Total Authorized Shares is the maximum number of shares a company is allowed to issue as laid out in its articles of incorporation.',
      othParValue: 'Par Value',
      othParValueTooltip:
        'The Par Value of a Share is the lowest legal price for which a company sells each one of its shares.',
      othTotalIssuedShares: 'Total Issued Shares',
      othTotalIssuedSharesLess: 'Total Issued Shares',
      othNominalValue: 'Nominal value per share',
      othTotalIssuedSharesTooltip:
        'Total issued shares refers to the total number of shares that a company is going to issue at the time of its incorporation.',
      othCurrency: 'Currency *',
      othTotalAuthorizedUnits: 'Total Authorized Units',
      othTotalIssuedUnits: 'Total Issued Units',
      othSelectCurrency: 'Select a currency',
      othPushYourDocument: 'Push your document',
      othOrSearchInYourComputer: 'Or search in your computer',
      othDocumentSupported: 'Documents supported: PDF or DOC | Maximum size: 30MB',
      othDashboard: 'Dashboard',
      othDashboardLogin: 'Log in',
      othNatureOfBusiness: 'Nature of Business (Economic substance)',
      othCategory: 'Category',
      othDescription: 'Description',
      othDeclarationAndConfirmation: 'Declaration and Confirmation',
      othDeclarationText:
        'By checking the box below, I hereby declare and confirm that all the information provided by me on this website is true and correct. Further, I hereby give my consent and authorization for the information contained here to be used for registration purposes on the chosen jurisdiction. I understand and accept that any misinformation or error caused by my completing the information required on this website may result in a charge to me for filing an amendment in the upcoming offshore company\'s documents. Additionally, should any changes occur in the information contained here, I will inform Offshore2go within seven (7) business days.',
      othEntityObligedToLawsBahamas: 'The entity is obliged to all laws and regulations in the Bahamas',
      othIDeclareAndConfirmAsAbove: 'I declare and confirm as above.',
      othDocumentsWaitingForApproval: 'Documents waiting for approval',
      othApprovalsBehindSchedule: 'Approvals behind schedule',
      othDocumentsMissingInfoFromCustomer: 'Documents missing info from customer',
      othDocumentsNewCompany: 'documents new company',
      othExpireProcess: 'Expire process',
      othFilterStatus: 'Filter Status',
      othPending: 'Pending',
      othPendingPayment: 'Pending',
      othRegisterOfNumbers: 'Total',
      othTotal: 'Total',
      othIncorporationFee: 'Incorporation Fee',
      othGovernmentFee: 'Government Fee',
      othNotApproved: 'Not Approved',
      othNoRegistrationNumber: 'Not defined',
      othNoIncorporationDate: 'Not defined',
      othPleaseProvideReason: 'Please provide the reason for rejection',
      othEnterReason: 'Enter reason...',
      othEnterAdditionalDetails: 'Enter additional details...',
      othRejectDocument: 'Reject',
      othApproved: 'Approved',
      othRegister: 'Registered',
      othWaitingApproval: 'Waiting for approval',
      othWaitingForMoreInfo: 'Waiting for More Info',
      othCreated: 'Created',
      othConfirmed: 'Confirmed',
      othCompleted: 'Paid',
      othRejected: 'Rejected',
      othCanceled: 'Canceled',
      othFailed: 'Failed',
      othExpired: 'Expired',
      othTypePaymentCredit: 'Credit Card',
      othTypePaymentDebit: 'Payment Debit',
      othPendingSignature: 'Pending Signature',
      othRows: 'Rows',
      othApprovalDocuments: 'Documents approval',
      othCheckPreApprovedDocument: 'Check pre-approved document',
      othSearch: 'Search',
      othSearchDocument: 'Search document',
      othSearchUsers: 'Search users',
      othUsers: 'Users',
      othNewService: 'New service',
      othShareholder: 'Shareholders',
      othScheduleSpecialist: 'Schedule specialist',
      othNewUser: 'New User',
      othDetails: 'Details',
      othSelectPeriod: 'Select period',
      othSearchCompany: 'Search company',
      othMailroom: 'Mailroom',
      othServiceConfig: 'Service Config',
      othApproveCompany: 'Approve company',
      othDocuments: 'Documents',
      othDirector: 'Director(s)',
      othNumberOfShares: 'Number of Shares*',
      othUnderages: 'Underages',
      othYear: 'Year',
      othMonth: 'Month',
      othEnquiry: 'Enquiry',
      othExceededTheShareLimit: 'Exceeded the share limit',
      othMinValue: 'The minimum limit is 1.',
      othMaxValue: 'The maximum limit is 50,000.',
      othThreeNamesMustDiffer: 'The three name options must be different.',
      othRole: 'Role',
      othBeneficialOwner: 'Beneficial owner',
      othIndividualDirectors: 'Individual directors',
      othCompanyAdmin: 'Company admin',
      othOrdinary: 'Ordinary',
      othEditDirector: 'Edit director',
      othMakeChangesProfile: 'Make changes to your profile here. Click save when youre done.',
      othCompleteRegister: 'Complete register',
      othStartApproval: 'Start Approval',
      othViewDocument: 'View document',
      othVisualiseDocument: 'View Company Info',
      othModalRejected: 'Modal Rejected',
      othReasonForRejection: 'Reason for rejection',
      othComplementaryMessage: 'Complementary message',
      othCancel: 'Cancel',
      othSave: 'Save',
      othModalApproved: 'Modal approved',
      othDocumentApproved: 'Approved Document',
      othDocumentReproved: 'Document not approved',
      othDocumentStatus: 'Document Status',
      othAreYouSureApprove: 'Are you sure you want to approve this document?',
      othApprove: 'Approve',
      othMoreInfo: 'Ask for more info',
      othJune: 'June',
      othJuly: 'July',
      othComplete: 'Complete',
      othNameForAgent: 'Name',
      othEmailForAgent: 'Email',
      othAlternativeNames: 'Alternative Names',
      othDetailsKyc: 'KYC Details',
      othOfTable: 'of',
      othAccordionItem: 'Accionista',
      othDirectorOption: 'directors',
      othCorporateDirectorOption: 'corporate directors'
    },

    options: {
      optPronounSr: 'Mr.',
      optPronounSra: 'Mrs.'
    },
    // Create Account Page
    OnboardingCreateAccountPageTitle: 'Create your account',
    OnboardingCreateAccountLabelName: 'Name',
    OnboardingCreateAccountLabelLastName: 'Last Name',
    OnboardingCreateAccountLabelPronoun: 'Pronoun',
    OnboardingCreateAccountLabelEmail: 'Email',
    OnboardingCreateAccountLabelPassword: 'Password',
    OnboardingCreateAccountLabelConfirmPassword: 'Confirm Password',
    OnboardingCreateAccountPlaceholderName: 'Example: Ariel',
    OnboardingCreateAccountPlaceholderLastName: 'Example: Souza',
    OnboardingCreateAccountPlaceholderPronoum: 'Select your pronoun',
    OnboardingCreateAccountPlaceholderEmail: 'Example: Ariel@offshore2go.com',
    OnboardingCreateAccountPlaceholderPassword: 'Example: 123#!2',
    OnboardingCreateAccountPlaceholderConfirmPassword: 'Example: 123#!2',
    OnboardingCreateAccountSelectOptionsPronounSr: 'Mr.',
    OnboardingCreateAccountSelectOptionsPronounSra: 'Mrs.',
    OnboardingCreateAccountErrorNameRequired: 'Please complete this field',
    OnboardingCreateAccountErrorLastNameRequired: 'Please complete this field',
    OnboardingCreateAccountErrorEmailRequired: 'Please complete this field',
    OnboardingCreateAccountErrorEmailMustBe: 'You must provide a valid email address',
    OnboardingCreateAccountErrorPasswordRequired: 'Please complete this field',
    OnboardingCreateAccountErrorConfirmPasswordRequired: 'Please complete this field',
    OnboardingCreateAccountErrorPasswordRule:
      'Must contain 8 characters, one uppercase, one lowercase, one number, and one special character.',
    OnboardingCreateAccountErrorConfirmPasswordMustMatch: 'Passwords must match',
    OnboardingCreateAccountErrorFileSize: 'File must be a maximum of 3MB',
    OnboardingCreateAccountErrorFileType: 'File must be a PDF or DOCX',
    OnboardingCreateAccountButtonNext: 'Next',
    OnboardingCreateAccountButtonBack: 'Back',

    // Create Objectives Page
    OnboardingObjectivesPageTitle: 'Set your objectives',
    OnboardingObjectivesLabelLegalPersonality: 'Legal personality',
    OnboardingObjectivesLabelMyObjects: 'My objectives are',
    OnboardingObjectivesDefaultSelectOptionLegalPersonality: 'Select an option',
    OnboardingObjectivesSelectOptionLegalPersonalityIndividual: 'Individual',
    OnboardingObjectivesSelectOptionLegalPersonalityStartup: 'Startup',
    OnboardingObjectivesSelectOptionLegalPersonalityOperationalCompany: 'Operational company',
    OnboardingObjectivesCheckBoxOptionMyObjectsFinancialInvestment: 'Financial investment',
    OnboardingObjectivesCheckBoxOptionMyObjectsBankAccount: 'Bank account',
    OnboardingObjectivesCheckBoxOptionMyObjectsBrokers: 'Brokers',
    OnboardingObjectivesCheckBoxOptionMyObjectsRealStateInTheUSA: 'Real estate in the USA',
    OnboardingObjectivesCheckBoxOptionMyObjectsRaiseCapitalFromInvestors: 'Raise capital from investors',
    OnboardingObjectivesCheckBoxOptionMyObjectsPassThroughOperation: 'Pass-through operation',
    OnboardingObjectivesCheckBoxOptionMyObjectsReceiveRevenuesFromCommercialTransactions:
      'Receive profits from commercial operations',
    OnboardingObjectivesCheckBoxOptionMyObjectsRoyalties: 'Royalties',
    OnboardingObjectivesSelectOptionErrorMustHave: 'You must select at least one objective',

    // Onboarding Justification Page
    OnboardingJurisdictionPageTitle: 'Set your jurisdiction',
    OnboardingJurisdictionBahamasOptionTitle: 'Incorporate in the Bahamas',
    OnboardingJurisdictionBahamasOptionDescription: 'Appointed director, mailroom, and registered address',
    OnboardingJurisdictionBahamasOptionTitleWhyChoose: 'Why choose this?',
    OnboardingJurisdictionBahamasOptionTextWhyChoose:
      'This is an instruction for you because we have helped over 1000 users open shops in Singapore',
    OnboardingJurisdictionBahamasEDelawareOptionTitle: 'Incorporate in the Bahamas and Delaware',
    OnboardingJurisdictionBahamasEDelawareOptionDescription: 'Appointed director, mailroom, and registered address',
    OnboardingJurisdictionBahamasEDelawareOptionTextWhyChoose:
      'Our 25 years of experience team has helped over 1,000 users establish offshore companies in the Bahamas, Cayman, Belize, and Delaware, among other jurisdictions.',
    OnboardingJurisdictionCaimanEDelawareOptionTitle: 'Incorporate in Cayman and Delaware',
    OnboardingJurisdictionCaimanEDelawareOptionDescription: 'Appointed director, mailroom, and registered address',
    OnboardingJurisdictionCaimanEDelawareOptionTextWhyChoose:
      'Our 25 years of experience team has helped over 1,000 users establish offshore companies in the Bahamas, Cayman, Belize, and Delaware, among other jurisdictions.',

    // Onboarding Directors Page
    OnboardingDirectorsInstructionCardDescription: 'Null',
    OnboardingDirectorsInstructionCardTitle: 'Instruction for you',
    OnboardingDirectorsLabelNumberOfDirectors: 'Number of directors',
    OnboardingDirectorsOptionHireCorporateDirector: 'I want to hire a corporate director',
    OnboardingDirectorsPageTitle: 'How many directors will your offshore company have?',
    OnboardingDirectorsTextOr: 'Or',
    OnboardingDirectorsTooltipNumberOfDirectors: 'Number of directors you want',

    // Onboarding Shareholders Page
    OnboardingShareholdersInstructionCardDescription: 'Null',
    OnboardingShareholdersInstructionCardTitle: 'Null',
    OnboardingShareholdersLabelNumberOfMinors: 'Number of minors',
    OnboardingShareholdersLabelNumbersOfshareholders: 'Number of shareholders',
    OnboardingShareholdersPageShareholderTitle: 'How many shareholders will you have?',
    OnboardingShareholdersPageUnderageTitle: 'How many underage shareholders will you have?',
    OnboardingShareholdersTooltipNumberOfMinors: 'Number of minors',
    OnboardingShareholdersTooltipNumbersOfshareholders: 'Number of shareholders',

    // Onboarding Addons Page
    OnboardingAddonsLabelSelectAddons: 'Select additional services',
    OnboardingAddonsOptionBasicAccounting: 'Basic accounting',
    OnboardingAddonsOptionDigitalMailRoom: 'Digital mailroom',
    OnboardingAddonsOptionFinancialStatement: 'Financial statement',
    OnboardingAddonsOptionPremiumAccountingServices: 'Premium accounting services',
    OnboardingAddonsOptionRegisterAddress: 'Registered address',
    OnboardingAddonsOptionYearlyReviewOfStructure: 'Yearly review of structure',
    OnboardingAddonsPageDescription: "Don't worry, you can change your preferences at any time",
    OnboardingAddonsPageTitle: 'Select additional services',

    // Onboarding Request Page
    OnboardingRequestInitPage: 'Your Requests',
    OnboardingRequestWhatDoNeed: 'What do i need?',
    OnboardingRequestProcessingTime: 'Processing Time',
    OnboardingRequestPrice: 'US$',
    OnboardingRequestActionSubmit: 'Create a new request',
    OnboardingRequestActionCheckout: 'Continue to checkout',
    OnboardingRequestStepsToExpect: 'Steps to expect',
    OnboardingRequestLoadingData: 'Loading...',
    OnboardingRequestCompleteRequest: 'Complete your request',
    OnboardingRequestNoData: 'There is no request in progress',
    OnboardingRequestFailed: 'Request Failed',
    OnboardingRequestList: 'List of requests',
    CLName: 'Name',
    CLCompanyName: 'Company Name',
    CLEmail: 'Email',
    CLCreated: 'Created',
    CLValue: 'Value',
    CLNumberRegister: 'Number Register',
    CLTitle: 'Title',
    CLStatus: 'Status',
    OnboardingDownloadDocument: 'Download Certificate',

    // Summary Page
    OnboardingSummaryButtonContinueToCheckout: 'Continue to payment',
    OnboardingSummaryPageTitle: 'Summary of your purchase',

    // PaymentSuccedded
    PaymentSucceddedTitle: 'Payment succeeded!',
    PaymentSucceddedSubTitle: 'Payment succeeded!',
    GoToDashboard: 'Go to dashboard',

    PaymentProcessingTitle: 'Payment Confirmation',
    PaymentProcessingDescription: 'Please wait while we confirm your payment...',

    // Others
    OthersSelectYourOption: 'Select an option',
    OthersOptionsSelect: 'Others...',
    PackageTitle: 'Your package - ',
    Required: 'Required',
    ContinueToCheckout: 'Continue to checkout',
    checkoutIsSecureTitle: "You'll be redirected to a secure ambient.",
    Annual: 'Annual',
    checkoutIsSecureText:
      "We are committed to the security of your information and want to ensure that your payment experience is completely reliable. By clicking the button below, you will be redirected to Stripe's secure payment environment, an internationally renowned platform recognized for its high-level security protocols.",

    PendingPaymentSelectCompany:
      'We have not yet identified the payment for your request. Please access the checkout page and complete the payment to proceed with the opening of your Offshore.',
    BtnPendingPaymentSelectCompany: 'Continue to checkout',
    BtnCreateNewOffshore: 'Create new offshore',
    othersTextCharacter: 'Characters',
    // Alert Messages
    AlertEnquiryMessage: 'The maximum file size is 5MB. Please try again',
    AlertFinishYourRegisterTitle: 'Congratulations!',
    AlertFinishYourRegisterMessage:
      'From here on, you can relax — Offshore2go will take care of everything, and your company will be up and running in 7 days.',
    AlertFinishYourRegisterButton: 'Got it',
    AlertContractTitle: 'Sign the user contract',

    // Transfer Company
    companyTransfer: {
      othTitlePageDirectors: 'Please insert the directors information',
      othTitlePageShareholders: 'Please insert the shareholders information',
      othTllCompanyRegistering: 'Please tell us more about your Company',
      othCompanyName: 'Company name*',
      othNumberRegisterCompany: 'Company Registration Number',
      othCompleteCompanyRegistration: 'Complete company registration',
      othJuridiction: 'Jurisdiction*',
      othUpladoDocument: 'Certificate of Incorporation*',
      othSelectJurisdiction: 'Select jurisdiction',
      othCheckCompanyDocument: 'I want Offshore2go to retrieve My Company Documents',
      othNumberShareholders: 'Number of shareholders',
      othNumberDirectors: 'Number of directors',
      othTotalAuthorizedShares: 'Total Authorized Shares*',
      othTotalIssuedShares: 'Total Issued Shares',
      othParValue: 'Par Value',
      othCurrency: 'Currency',
      othSelectedCurrency: 'Selected currency',
      othComplementTransfer: 'Complement',
      othWarningRegisterCompany: 'You can proceed to the next step, this one has already been completed.',
      othWarningDontRegisterCompany: 'You can proceed to the next step you do not need to fill in this information.',
      othModalTitleInformation: 'How Offshore2go retrieves my documents?',
      othModalInformation:
        "You can save time by paying a small fee, so you don't need to upload all of your company documents.",
      descriptionText: 'Certificate Incorporation'
    },
    certificatesDocuments: {
      CERTIFICATE_INCORPORATION: 'Certificate of Incorporation',
      FIRST_DIRECTORS_RESOLUTION: 'First Directors Resolution',
      ACCOUNTING_DECLARATION: 'Accounting Declaration',
      FORM_D: 'Form D (Controlling Parties Form)',
      SEAL_COPY: 'Company Seal Copy',
      MEMORANDUM_ASSOCIATION: 'Memorandum of Association',
      REGISTER_MEMBERS: 'Register of Members',
      REGISTER_DIRECTORS: 'Register of Directors',
      CERTIFICATE_SHARES: 'Certificate of Shares',
      CERTIFICATE_COMPLIANCE: 'Certificate of Compliance',
      'Certificate of Shares': 'Certificate of Shares',
      ARTICLES_ASSOCIATION: 'Articles of Association',
      Accounting: 'Accounting',
      Alterações: 'Changes',
      Certificados: 'Certificates',
      Certificates: 'Certificates',
      Changes: 'Amendments',
      Constituição: 'Incorporation',
      Contabilidade: 'Accounting',
      Forms: 'Forms',
      Formulários: 'Forms',
      Incorporation: 'Incorporation',
      'Other Documents': 'Other Documents'
    },
    jurisdictionTitles: {
      bahamas: 'BAHAMAS'
    },
    accountingModule: {
      welcomeAccounting:
        'Welcome to the Accounting module! Here you can see all of your transaction information, connect with your bank account to retrieve the transactions history, add manual transactions, generate a balance sheet, and also submit it to the review of an accounting agent.',
      addManualTransactions: 'Add manual transactions',
      selectBank: 'Select Bank',
      connectYourBank: 'Connect your bank',
      titleConnectBank:
        "You will be redirected to Plaid's website where you can register and connect with your preferred Bank Account.",
      infoConnectBank: 'Offshore2Go will be able to: ',
      goConnectBank: ' Read transaction history',
      btnConnectManual: 'Add Manual Bank',
      btnConnectPlaid: 'Connect With Plaid',
      categoryList: 'Category',
      searchCategories: 'Search categories...'
    },
    billingPayments: {
      billingPaymentsSubtitle: 'View and manage your payments and invoices',
      billingPaymentsTitle: 'Billing & Payments',
      billingPaymentsFilterDescription: 'Filter your transactions',
      billingPaymentsSearchPlaceholder: 'Search transaction',
      billingPaymentsDescription: 'Description',
      billingPaymentsAmount: 'Amount',
      billingPaymentsDate: 'Date',
      billingPaymentsPaymentMethod: 'Payment Method',
      billingPaymentsStatus: 'Status',
      billingPaymentsType: 'Type'
    },
    enquiry: {
      enquirySubtitle: 'Contact us and ask your questions',
      enquiryMessagePlaceholder: 'Type your message here...'
    },
  accounting: {
    accountingSubtitle: 'Manage your transactions and financial categories',
    period: 'Period',
    open: 'Open',
    days: 'days',
    leftToEndMonth: 'left to end the month',
    output: 'Output',
    input: 'Input',
    noCategory: 'No category',
    noTransactionsYet: 'No transactions recorded yet',
    featureComingSoon: 'This feature will be available soon'
  },
    annualFee: {
      title: 'Annual Fee Configuration (by jurisdiction and company type)',
      loading: 'Loading...',
      error: 'Error fetching configurations.',
      noConfig: 'No configuration found.',
      companyType: 'Company type',
      amount: 'Amount',
      tooltipAmountMin: 'You cannot set the amount below the minimum value currently displayed for this configuration.',
      dueDate: 'Due date',
      description: 'Description',
      save: 'Save',
      saving: 'Saving...',
      saved: 'Saved!',
      saveError: 'Error saving.',
      companyTypes: {
        new_company: 'New Company',
        transfer_company: 'Transfer Company'
      }
    },
    KYCDocuments: {
      statusKYC: {
        blocked: 'Rejected',
        pending: 'Pending',
        approved: 'Approved'
      },
      detailsKYC: {
        Enforcements: 'Enforcements',
        PEPs: 'Politically Exposed Persons (PEPs)',
        Source: 'Source',
        Country: 'Country',
        SubCategories: 'SubCategories',
        GoverningRole: 'Governing Role',
        ExpirationDate: 'Expiration Date'
      },
      notFound: 'There are no restrictions for this person.'
    },
    incorporation: {
      cardTitle: 'Incorporation Status',
      progress: 'Stage {{current}} of {{total}}',
      client: 'Client',
      currentStage: 'Current stage',
      viewTracking: 'Track progress',
      estimatedCompletion: 'Estimated completion',
      jurisdictionEstimate: 'Estimated timeline for {{jurisdiction}}',
      nextStageEstimate: 'Estimated time for the next stage: {{count}} business days',
      stageLabel: 'Stage {{number}}',
      completedAt: 'Completed on {{date}}',
      waitingTitle: 'We need a document from you',
      uploadLabel: 'File',
      chooseFile: 'Choose file',
      upload: 'Upload document',
      uploadSuccess: '{{name}} uploaded. The review has resumed.',
      history: 'History',
      historyTitle: 'Incorporation history',
      responsible: 'Owner',
      notStarted: 'Tracking starts after the incorporation payment is confirmed.',
      fileHint: 'PDF, DOC, DOCX, JPG or PNG. Maximum 10 MB.',
      sending: 'Sending...',
      historyEmpty: 'No events recorded.',
      loading: 'Loading tracking...',
      adminTitle: 'Incorporation Status',
      adminHint: 'Complete the current stage or record a pending item for the client.',
      advance: 'Complete current stage',
      cannotSkip: 'You can only move to the next stage after the previous one is complete.',
      cannotAdvance: 'This stage could not be advanced.',
      cannotAdvanceWaiting: 'Resolve the client pending item before moving forward.',
      advanced: 'Stage updated.',
      registerPendency: 'Record pending item',
      pendencyPlaceholder: 'Describe what the client needs to send',
      pendencySaved: 'Pending item recorded. The stage is now Waiting on client.',
      retry: 'Try again',
      errors: {
        load: 'Tracking could not be loaded.',
        action: 'This action could not be completed.',
        fileType: 'Upload a PDF, DOC, DOCX, JPG or PNG file.',
        fileTooLarge: 'The file must be 10 MB or smaller.'
      },
      status: {
        completed: 'Completed',
        in_progress: 'In progress',
        waiting_customer: 'Waiting on client',
        not_started: 'Not started'
      },
      stages: {
        order_received: {
          title: 'Order received',
          description: 'Payment is confirmed and the company opening request is in the queue.'
        },
        documents_review: {
          title: 'Documents under review',
          description: 'The team is checking identity and documents, including KYC and due diligence.'
        },
        sent_to_registry: {
          title: 'Sent to the registry',
          description: 'The filing has been submitted to the jurisdiction’s official registry.'
        },
        company_registered: {
          title: 'Company registered',
          description: 'The certificate of incorporation has been issued.'
        },
        documents_available: {
          title: 'Documents available',
          description: 'The corporate kit is available in the documents section.'
        }
      },
      historyTypes: {
        stage_advanced: 'Stage updated: {{stage}}',
        pendency_opened: 'Pending item opened on {{stage}}',
        document_sent: 'Document uploaded on {{stage}}',
        migrated_from_legacy: 'Tracking started from the previous process. Stage: {{stage}}'
      }
    },
    preferences: {
      subtitle: 'Manage your account settings and preferences',
      profileSettings: 'Profile Settings',
      security: 'Security',
      profileInformation: 'Profile Information',
      profileDescription: 'Your personal account details',
      accountMember: 'User',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      notProvided: 'Not provided',
      languagePreferences: 'Language Preferences',
      chooseLanguage: 'Choose your preferred language',
      languageUpdated: 'Language updated successfully',
      updatePasswordDescription: 'Update your password to keep your account secure',
      enterNewPassword: 'Enter new password',
      confirmNewPassword: 'Confirm new password',
      passwordRequirements: 'Password must contain at least 8 characters, including uppercase, lowercase, number and special character.'
    }
  }
};

export default translate_en;
